import React from "react";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {Input} from "@/components/ui/input";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";
import {provinces} from "@/components/FormLead";
import {Textarea} from "@/components/ui/textarea";
import PermutaValutazioneSection from "@/components/vendi/form-permuta-steps/PermutaValutazioneSection";

interface StepDatiClienteProps {
    formDatiCliente: any;
    formDettagliGenerali: any;
    eurotaxValutazione?: EurotaxValutazione | null;
    isValutazioneLoading?: boolean;
    isClienteProfileComplete?: boolean;
    isManualValutazioneOverride?: boolean;
    onEnableValutazioneOverride?: () => void;
    onDisableValutazioneOverride?: () => void;
    showValutazioneSection?: boolean;
}

const StepDatiCliente: React.FC<StepDatiClienteProps> = ({
    formDatiCliente,
    formDettagliGenerali,
    eurotaxValutazione,
    isValutazioneLoading = false,
    isClienteProfileComplete = false,
    isManualValutazioneOverride = false,
    onEnableValutazioneOverride,
    onDisableValutazioneOverride,
    showValutazioneSection = false,
}) => {
    return (
        <Form {...formDatiCliente}>
            <form id="formDatiCliente" onSubmit={formDatiCliente.handleSubmit(() => {})}
                  className="grid grid-cols-2 gap-4">

                <FormField control={formDatiCliente.control} name="nome"
                           render={({field, fieldState}) => (
                               <FormItem>
                                   <FormLabel>Nome</FormLabel>
                                   <FormControl>
                                       <Input {...field} placeholder="Inserisci il nome"/>
                                   </FormControl>
                                   <FormMessage>{fieldState.error?.message}</FormMessage>
                               </FormItem>
                           )}
                />

                <FormField control={formDatiCliente.control} name="cognome"
                           render={({field, fieldState}) => (
                               <FormItem>
                                   <FormLabel>Cognome</FormLabel>
                                   <FormControl>
                                       <Input {...field} placeholder="Inserisci il cognome"/>
                                   </FormControl>
                                   <FormMessage>{fieldState.error?.message}</FormMessage>
                               </FormItem>
                           )}
                />

                <FormField control={formDatiCliente.control} name="telefono"
                           render={({field, fieldState}) => (
                               <FormItem>
                                   <FormLabel>Telefono *</FormLabel>
                                   <FormControl>
                                       <Input
                                           {...field}
                                           type="tel"
                                           inputMode="numeric"
                                           autoComplete="tel"
                                           required
                                           aria-required="true"
                                           placeholder="Inserisci il numero di telefono"
                                       />
                                   </FormControl>
                                   <FormMessage>{fieldState.error?.message}</FormMessage>
                               </FormItem>
                           )}
                />

                <FormField control={formDatiCliente.control} name="provincia"
                           render={({field, fieldState}) => (
                               <FormItem>
                                   <FormLabel>Provincia</FormLabel>
                                   <FormControl>
                                       <Select {...field}
                                               onValueChange={(value) => field.onChange(value)}
                                               value={field.value}>
                                           <SelectTrigger>
                                               <SelectValue placeholder="Seleziona la provincia"/>
                                           </SelectTrigger>
                                           <SelectContent>
                                               {provinces.map((province) => (
                                                   <SelectItem key={province.code} value={province.code}>
                                                       {province.name}
                                                   </SelectItem>
                                               ))}
                                           </SelectContent>
                                       </Select>
                                   </FormControl>
                                   <FormMessage>{fieldState.error?.message}</FormMessage>
                               </FormItem>
                           )}
                />

                <FormField control={formDatiCliente.control} name="targa"
                           render={({field, fieldState}) => (
                               <FormItem>
                                   <FormLabel>Targa</FormLabel>
                                   <FormControl>
                                       <Input {...field} placeholder="Es. AB123CD"/>
                                   </FormControl>
                                   <FormMessage>{fieldState.error?.message}</FormMessage>
                               </FormItem>
                           )}
                />

                <FormField control={formDatiCliente.control} name="note"
                           render={({field, fieldState}) => (
                               <FormItem className="col-span-2">
                                   <FormLabel>Note</FormLabel>
                                   <FormControl>
                                       <Textarea {...field} placeholder="Aggiungi eventuali note"/>
                                   </FormControl>
                                   <FormMessage>{fieldState.error?.message}</FormMessage>
                               </FormItem>
                           )}
                />

                {showValutazioneSection ? (
                    <div className="col-span-2">
                        <PermutaValutazioneSection
                            formDatiCliente={formDatiCliente}
                            eurotaxValutazione={eurotaxValutazione}
                            isValutazioneLoading={isValutazioneLoading}
                            isClienteProfileComplete={isClienteProfileComplete}
                            isManualValutazioneOverride={isManualValutazioneOverride}
                            onEnableValutazioneOverride={onEnableValutazioneOverride ?? (() => {})}
                            onDisableValutazioneOverride={onDisableValutazioneOverride ?? (() => {})}
                        />
                    </div>
                ) : null}
            </form>
        </Form>
    );
};

export default StepDatiCliente;
